/* ---------- BS-001's -XD2 field blocks numbered (#3523 item 4: a strip's terminals are numbered; the lead's yes, 6489774398) ----------
 * -XD2's blocks for the outside contacts and the battery management's 0 V were named after the pin their field cable continues to
 * ("XD2:GB1-BQ1:11"); they are numbered now, on after the status signals' blocks 1 to 5 (parts.ts, xd2FieldBlocks). A save made before
 * names them the old way in every terminal reference (the wires as built, "XD2:GB1-BQ1:11"), so each is renamed to its number. The
 * drawings' own references to the outside pins ("GB1-BQ1:11", no strip) stay. The save migration in packages/progress uses this
 * (format 32); nothing else does. Self-contained on purpose: the migration imports this file alone, not BS-001's pack. */

/** Each field block's old name on -XD2 and its number, in the strip's order. */
export const BS001_XD2_NUMBERS: Readonly<Record<string, string>> = {
  "GB1-BQ1:11": "6", "GB1-BQ1:12": "7", "GB1-KF5:11": "8", "GB1-KF5:14": "9", "GB1-EQ1:11": "10", "GB1-EQ1:14": "11",
  "GB1-TC1:11": "12", "GB1-TC1:14": "13", "GB1-KF1:0V": "14" };

/** A field block where it stands in a reference ("XD2:GB1-BQ1:11"), never another strip's or a longer tag's. */
const ON_XD2 = /(?<![\w-])XD2:(GB1-[A-Z]+\d+:\w+)/g;
const renamed = (s: string) => s.replace(ON_XD2, (t: string, pin: string) => pin in BS001_XD2_NUMBERS ? `XD2:${BS001_XD2_NUMBERS[pin]}` : t);

function walk(v: any): any {
  if (typeof v === "string") return renamed(v);
  if (Array.isArray(v)) return v.map(walk);
  if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, x]) => [renamed(k), walk(x)]));
  return v;
}

const one = <A extends { model?: any; ui?: any }>(s: A): A => {
  const asText = typeof s.model === "string", model = s.model === undefined ? undefined : walk(asText ? JSON.parse(s.model) : s.model);
  return { ...s, ...(s.model !== undefined ? { model: asText ? JSON.stringify(model) : model } : {}), ...(s.ui !== undefined ? { ui: walk(s.ui) } : {}) };
};
/** A saved BS-001 project ({ model, ui }, the model as a JSON string or an object, as saved) with -XD2's field blocks numbered: its own
 *  work and each earlier attempt it keeps ("Start again", #1220). */
export function numberBs001Xd2<T extends { model?: any; ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
